import { Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box } from '@bonusly/design-system';

export const RelevantHelper = (): ReactElement => {
	const { t } = useTranslation('celebrations');
	return (
		<Accordion allowToggle bgColor="secondary.bgAlpha" borderRadius="md" px={3} py={3.5} mt={4}>
			<AccordionItem border="none">
				<Box as="h2">
					<AccordionButton p={0} _hover={{ bgColor: 'transparent' }}>
						<Box as="span" color="text.default" flex="1" fontSize={50} fontWeight="semibold" lineHeight={5} textAlign="left">
							{t('modal.explaination_header')}
						</Box>
						<AccordionIcon />
					</AccordionButton>
				</Box>
				<AccordionPanel p={0} mt={2}>
					<Text color="text.default" fontSize={50} fontWeight="normal" lineHeight={5}>
						{t('modal.explaination_message')}
					</Text>
				</AccordionPanel>
			</AccordionItem>
		</Accordion>
	);
};
